export { default } from './Alert'


// WEBPACK FOOTER //
// ./src/components/Alert/index.js